import {Reducer} from 'redux'
import {NotificationsActionTypes, NotificationsState} from './types';
import NotificationsService from "../../services/NotificationsService";

// Type-safe initialState!
const initialState: NotificationsState = {
	list: []
}

// Thanks to Redux 4's much simpler typings, we can take away a lot of typings on the reducer side,
// everything will remain type-safe.
const reducer: Reducer<NotificationsState> = (state = initialState, action) => {
	switch (action.type) {
		case NotificationsActionTypes.FETCH_ALL_REQUEST: {
			NotificationsService.getAll()
			return { ...state, loading: true }
		}
		case NotificationsActionTypes.FETCH_ALL_COMPLETED: {
			return { ...state, loading: false, list: action.payload}
		}
		case NotificationsActionTypes.FETCH_ONE_REQUEST: {
			NotificationsService.getOne(action.payload)
			return { ...state, loading: true }
		}
		case NotificationsActionTypes.FETCH_ONE_COMPLETED: {
			// updates list but I do not see usage of this at the moment
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1, action.payload)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case NotificationsActionTypes.SAVE_REQUEST: {
			NotificationsService.save(action.payload)
			return { ...state, loading: true }
		}
		case NotificationsActionTypes.SAVE_COMPLETED: {
			console.log(action.payload)
			return { ...state, loading: false}
		}
		case NotificationsActionTypes.DELETE_REQUEST: {
			NotificationsService.delete(action.payload)
			return { ...state, loading: true }
		}
		case NotificationsActionTypes.DELETE_COMPLETED: {
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case NotificationsActionTypes.DELETE_MULTIPLE_REQUEST: {
			NotificationsService.deleteMultiple(action.payload)
			return { ...state, loading: true }
		}
		case NotificationsActionTypes.DELETE_MULTIPLE_COMPLETED: {
			action.payload.forEach((item: any) => {
				let foundIndex = state.list.findIndex(element => element.id === item.id)
				state.list.splice(foundIndex, 1)
			});
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case NotificationsActionTypes.MARKSEEN_REQUEST: {
			NotificationsService.markSeen(action.payload)
			return { ...state,}
		}
		default: {
			return state
		}
	}
}

// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
export {reducer as NotificationsReducer}
